import { CommitmentsVersionsService_commitmentVersionsServiceGetLatest } from '@festina/life-general-types/life/hooks/CommitmentsVersionsService_commitmentVersionsServiceGetLatest'

export const useLazyFetchLatestCommitmentVersion =
  CommitmentsVersionsService_commitmentVersionsServiceGetLatest.useLazyQuery
